import React, { useRef } from "react";
import { Close as CloseIcon } from "@actinc/dls/icons/";
import { Card, CardContent, CardHeader, IconButton } from "@mui/material";

const WorkspaceCard = React.forwardRef(
  ({ children, className, close, style, title, ...props }, ref) => {
    const headerRef = useRef();

    return (
      <Card
        className={className}
        raised={true}
        ref={ref}
        style={style}
        sx={{ borderRadius: "8px", display: "flex", flexDirection: "column" }}
        {...props}
      >
        {(!!title || !!close) && (
          <CardHeader
            action={
              !!close && (
                <IconButton
                  aria-label="close card"
                  onClick={() => {
                    close();
                  }}
                  size="small"
                  sx={{
                    backgroundColor: "inherit",
                    color: "primary.contrastText",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )
            }
            ref={headerRef}
            sx={{
              backgroundColor: "#005274",
              color: "primary.contrastText",
              cursor: "move",
              paddingX: 2,
              paddingY: 1,
            }}
            title={title || ""}
          />
        )}
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 1,
            height: headerRef?.current
              ? `calc(100% - ${
                  headerRef.current.getBoundingClientRect().height
                }px)`
              : undefined,
            overflowY: "auto",
            paddingBottom: "0 !important",
            paddingLeft: 2,
            paddingRight: 2,
            paddingTop: 0,
          }}
        >
          {children}
        </CardContent>
      </Card>
    );
  },
);

export { WorkspaceCard };
